import { Flex, Heading } from '@chakra-ui/react'

import SettingsBreadcrumb from '../../components/SettingsBreadcrumb'
import withAuth from '../../contexts/AuthContext/withAuth'
import Calendar from '../Calendar'
import GridPaginaInicial from './GridPaginaInicial'

const Inicio = () => {
  return (
    <Flex p="40px" bgColor="#fafafa" direction="column" w="100%">
      <SettingsBreadcrumb />
      <Heading
        mt="30px"
        mb="20px"
        fontWeight="600"
        fontSize="21px"
        color="#6F6F6F"
        w="100%"
      >
        Página Inicial
      </Heading>
      <div style={{marginBottom:'1.5em', marginTop:'1.5em'}}>
        <GridPaginaInicial />
      </div>
      <hr style={{maxWidth: '1800px'}}/>
      <div>
        <Calendar />
      </div>
    </Flex>
  )
}

export default withAuth(Inicio)
